import {Controller} from "@hotwired/stimulus";

// Connects to data-controller="reveal"
export default class extends Controller {
  static targets = ["item", "product"];

  toggle(event) {
    const targetName = event.currentTarget.dataset.revealTargetSelector;
    const items = this[`${targetName}Targets`];

    items.forEach((item) => item.classList.toggle("hidden"));

    // HACK/DIRTY TRICK: Manage reveal via "group".
    // "hidden" is overridden by Tailwind (`!hidden` and `group-[.reveal-item]:!block`),
    // so the default toggle via the hidden class is ignored.
    // This CSS-based approach prevents state loss when Turbo replaces HTML from the server
    // (which would otherwise reset the hidden state).
    this.element.classList.toggle(`reveal-${targetName}`);
  }

  show(event) {
    const targetName = event.currentTarget.dataset.revealTargetSelector;
    const items = this[`${targetName}Targets`];

    items.forEach((item) => item.classList.remove("hidden"));
  }

  hide(event) {
    const targetName = event.currentTarget.dataset.revealTargetSelector;
    const items = this[`${targetName}Targets`];

    items.forEach((item) => item.classList.add("hidden"));
  }
}
